// ©2024 Austin App House. All rights reserved.
import React from 'react';
import FieldLabel from '../../FieldLabel';

const InputField = field => {
  const wrapperClass = field.paddingBottomClassName === ''
    ? 'dashboard-field-control'
    : (field.paddingBottomClassName || 'padding-bottom-10');

  return (
    <div className={wrapperClass}>
      <div className={`flex-box justify-content-between ${field.className || ''}`}>
        <FieldLabel
          label={field.label}
          className={field.labelClassName}
          required={field.required}
        />
        <span className={field.dimensionClassName}>
          <input
            /* eslint-disable-next-line react/jsx-props-no-spreading */
            {...field.input}
            type={field.type}
            placeholder={field.placeholder}
            required={field.required}
            className={field.inputClassName}
            disabled={field.disabled}
            title={field.title || ''}
            min={field.min}
            max={field.max}
            step={field.step}
            style={field.dimension ? ({ paddingRight: 0 }) : ({})}
          />
          {field.dimension || ''}
        </span>
      </div>
      {
        field.meta.touched && field.meta.error
        && <span style={{color: 'red'}} className="span-error">{field.meta.error}</span>
      }
    </div>
  )
};

export default InputField;
